import { Body, Card, CardContent } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useMitarbeiterabgleich } from '../../hooks/useMitarbeiterabgleich/useMitarbeiterabgleich';
import { AbgleichFilterLeiste } from './AbgleichFilterLeiste';
import { AbgleichKopf } from './AbgleichKopf';
import { AbgleichTabelle } from './AbgleichTabelle';
import { AuswahlUebernahme } from './AuswahlUebernahme';
import { UebernehmenSpalte } from './UebernehmenSpalte';
import { useAbgleichAuswahl } from '../../hooks/useMitarbeiterabgleich/useAbgleichAuswahl';
import { useStandortZuordnung } from '../../hooks/useMitarbeiterabgleich/useStandortZuordnung';
import { StandortZuordnungDialog } from './StandortZuordnung/StandortZuordnungDialog';

export function MitarbeiterAbgleichCard() {
  const { t } = useTranslation();
  const {
    zeilen,
    zusammenfassung,
    standorte,
    error,
    starteAbgleich,
    uebernehme,
  } = useMitarbeiterabgleich();
  const auswahl = useAbgleichAuswahl(zeilen);
  const zuordnung = useStandortZuordnung(uebernehme);

  if (!zusammenfassung) {
    return (
      <Card>
        <CardContent>
          <Body>{error ?? t('domain.datev.abgleich.ladefehler')}</Body>
        </CardContent>
      </Card>
    );
  }

  const jobLaeuft = zusammenfassung.letzterJob?.status === 'inProgress';

  return (
    <Card>
      <CardContent className="flex flex-col gap-6">
        <AbgleichKopf
          zusammenfassung={zusammenfassung}
          abweichungen={zeilen.length}
          onAbrufStarten={starteAbgleich}
        />
        <AbgleichFilterLeiste anzahl={zeilen.length} />
        <AuswahlUebernahme
          zeilen={zeilen}
          selectedIds={auswahl.selectedIds}
          onUebernehmen={uebernehme}
          onStandorteZuordnen={zuordnung.oeffneZuordnung}
        />
        <StandortZuordnungDialog
          zeilen={zuordnung.offeneZuordnung?.ohneStandort ?? null}
          standorte={standorte}
          onOpenChange={(open) => !open && zuordnung.schliesseZuordnung()}
          onFertig={zuordnung.zuordnungFertig}
        />

        <div className="overflow-x-auto">
          <div className="grid min-w-[1000px] grid-cols-[1fr_78px_1fr]">
            <AbgleichTabelle
              titel="e2n"
              quelle="e2n"
              zeilen={zeilen}
              auswahl={auswahl}
              disabled={jobLaeuft}
            />
            <UebernehmenSpalte
              zeilen={zeilen}
              onUebernehmen={zuordnung.uebernehmeEinzeln}
              disabled={jobLaeuft}
            />
            <AbgleichTabelle titel="DATEV" quelle="datev" zeilen={zeilen} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
